import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';

import { get } from "lodash";
import { Loader2 } from 'lucide-react';
import { toJS } from 'mobx';
import queryString from 'query-string';

import HeaderContainerGrid from '@/components/headerContainer/Grid';
import { ReportBody } from '@/components/reports/body';
import AuditStore from 'modules/report/stores/audit';
import { LOADING } from 'stores/BaseStore';
import history from 'utils/history';

import AuditResults from './components/AuditResults';
import Header from './components/Header';

function ReportsAuditLayout() {
  const [state, setState] = useState({})
  const [, setResultsTick] = useState(0)

  const loadData = async search => {
    setResultsTick(t => t + 1)
    try {
      return await AuditStore.getAudit(search)
    } finally {
      setResultsTick(t => t + 1)
    }
  }

  const loadByQuery = search => {
    const params = parseParams(search)

    const { key, value } = params
    setState(prevState => ({ ...prevState, key, value }))

    loadData(params).then(({ data }) => {
      const key = params.key !== "id" ? params.key : "email"
      const value = data ? get(Object.values(data), `[0][0].user.${key}`) : ""
      setState(prevState => ({ ...prevState, key, value }))
    })
  }

  const parseParams = search => {
    try {
      const query = queryString.parse(search)
      if (query && query.configure) {
        return JSON.parse(atob(query.configure))
      }
    } catch (error) {
      history.push('/reports/audit')
    } finally {
      history.replace({ search: '' })
    }
  }

  const RenderResults = () => {
    const isLoading = AuditStore.status === LOADING;

    if (isLoading) {
      return <div className='flex justify-center items-center h-20'>
        <Loader2 size='24' className='animate-spin' />
      </div>
    }

    return AuditStore.data && <AuditResults data={Object.entries(toJS(AuditStore.data))} />
  }

  useEffect(() => {
    const { location: { search } } = history
    if (search) {
      loadByQuery(search)
    }
  }, [])

  return <>
    <HeaderContainerGrid title='Audit Report' />
    <ReportBody contentClassName='group p-4'>
      <Helmet title="Audit" />
      <Header data={state} onSearch={loadData} />
      <RenderResults />
    </ReportBody>
  </>
}

export default ReportsAuditLayout;
